import logout from '../../../../api/logout';
import { getWindow } from '../../../../helpers/getBrowserGlobals';

export const performLogout = async (rootUrl: string): Promise<void> => {
  await logout(rootUrl);

  const params = new URLSearchParams(getWindow()?.location.search);
  let redirectUrl = rootUrl;

  // if the rootUrl is not set, the assign function will reload the
  // current page which could contain the email_validation token resulting
  // in the user being logged back in again.
  if (rootUrl === '' && params.has('email_validation')) {
    params.delete('email_validation');
    redirectUrl = `?${params.toString()}`;
  }

  getWindow()?.location.assign(redirectUrl);
};
